import { toggleSidebar } from "ra-core";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { AppBar, Tooltip } from "@material-ui/core";
import { makeStyles, IconButton, Grid } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

import sfLogo from "../assets/icons/sf.png";
import MyUserMenu from "./MyUserMenu";
import preval from "preval.macro";

//import useStyles from "../styles";
const useStyles = makeStyles((theme) => ({
  appBar: {
    height: 70,
    maxHeight: 70,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    // gridTemplateColumns: "auto auto auto",
    alignItems: "center",
  },
  menuButton: {
    marginLeft: "0.2em",
    marginRight: "0.2em",
    justifySelf: "start",
  },
  menuButtonIconClosed: {
    transition: theme.transitions.create(["transform"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    transform: "rotate(0deg)",
    justifySelf: "start",
  },
  menuButtonIconOpen: {
    transition: theme.transitions.create(["transform"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    transform: "rotate(180deg)",
    justifySelf: "start",
  },
  toolBar: {
    minWidth: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  title: {
    flex: 1,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  logo: {
    width: 103,
    height: 30,
    justifySelf: "center",
  },

  userMenu: {
    justifySelf: "end",
  },

  gridCenter: {
    textAlign: "center",
    alignSelf: "center",
  },
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: theme.spacing(1),
  },
}));

const MyAppBar = (props) => {
  const { open, disabledMenu = false, disabledBack = false } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const buildDate = preval`module.exports = new Date().toUTCString()`;
  let hideBack;

  if (history.location.pathname === "/") {
    hideBack = true;
  } else hideBack = false;
  return (
    <AppBar {...props} className={classes.appBar} color="primary">
      <Grid container sm={12}>
        <Grid item sm={4} style={{ alignSelf: "center" }}>
          {disabledMenu ? null : (
            <IconButton
              color="inherit"
              onClick={() => (disabledMenu ? null : dispatch(toggleSidebar()))}
              className={classes.menuButton}
            >
              <MenuIcon
                classes={{
                  root: open
                    ? classes.menuButtonIconOpen
                    : classes.menuButtonIconClosed,
                }}
              />
            </IconButton>
          )}
          {!hideBack && (
            <IconButton
              color="inherit"
              onClick={() => (disabledBack ? null : history.goBack())}
              className={classes.menuButton}
            >
              {disabledBack ? null : <ArrowBackIosIcon />}
            </IconButton>
          )}
        </Grid>

        <Grid item sm={4} className={classes.gridCenter}>
          <Tooltip title={`${process.env.REACT_APP_COMMIT_HASH}:${buildDate}`}>
            <img src={sfLogo} alt="sflogo" className={classes.logo} />
          </Tooltip>
        </Grid>

        <Grid item sm={4} style={{ alignSelf: "center" }}>
          <MyUserMenu />
        </Grid>
      </Grid>
    </AppBar>
  );
};
/*
const OldAppBar = (props) => {
  const classes = useStyles();
  const { handle } = props;
  const [height, setHeight] = useState(70);
  return (
    <AppBar {...props} style={{ height: height }} userMenu={<MyUserMenu />}>
      <img src={sfLogo} alt="sflogo" />
      <div style={{ width: 20 }}></div>
      <Button
        onClick={() => {
          handle.enter();
        }}
      >
        Full
      </Button>
      <Button
        onClick={() => {
          handle.exit();
        }}
      >
        Small
      </Button>
      <Button
        onClick={() => {
          setHeight(5);
        }}
      >
        Hide
      </Button>
      <Button
        onClick={() => {
          setHeight(70);
        }}
      >
        Show
      </Button>
    </AppBar>
  );
};
*/
/*TO show title use
<Typography
        variant="h6"
        color="inherit"
        className={classes.appBar.title}
        id="react-admin-title"
      />
      
      Handle Fullscreen
      <AppBar {...props} style={{ height: height }} userMenu={<MyUserMenu />}>
      <img src={sfLogo} alt="sflogo" />
      <div style={{ width: 20 }}></div>
      <Button
        onClick={() => {
          handle.enter();
        }}
      >
        Full
      </Button>
      <Button
        onClick={() => {
          handle.exit();
        }}
      >
        Small
      </Button>
      <Button
        onClick={() => {
          setHeight(5);
        }}
      >
        Hide
      </Button>
      <Button
        onClick={() => {
          setHeight(70);
        }}
      >
        Show
      </Button>
    </AppBar>
      
      */

export default MyAppBar;
